import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import moment from 'moment';

/** MUI */
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { TextField } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import proyectoService from '../services/proyecto.service';
import usuarioService from '../services/usuario.service';

/** Servicios */
import personaService from "../services/persona.service";
import mutuoService from "../services/mutuo.service";

/** Definiciones */
const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const MutuoADCFinal = () => {
    const [persona, setPersona] = useState('');
    const { id_mutuo } = useParams();
    const [expanded, setExpanded] = useState(false);
    const [comentario, setComentario] = useState('');
    const [mutuo, setMutuo] = useState('');
    //const user = JSON.parse(localStorage.getItem('user'));
    const navigate = useNavigate();

    useEffect(() => {
        //if (!user) return navigate("/login");
        retreiveMutuo(id_mutuo);
    }, []);

    async function retreviePersona(_rut) {
        try {
            const pers = await personaService.getPorRut(_rut);
            setPersona(pers.data[0]);
        } catch (e) {
            console.error(e);
        }
    }

    async function retreiveMutuo(_id) {
        try {
            const mutuo = await mutuoService.getByID(_id);
            console.log("Mutuo", mutuo.data);
            setMutuo(mutuo.data);
            setPersona(mutuo.data.persona);
        } catch (err) {
            console.log(err);
        }
    }

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const enviar = () => {
        if (!comentario) {
            alert("Debe ingresar un comentario!!");
            return;
        } else {
            console.log("Comentario", comentario);
            mutuoService.update(mutuo.id, { comentario_final: comentario })
                .then(response => {
                    console.log(response);
                }).catch(err => {
                    console.error(err);
                });
        }
    };

    const abrirRuta = () => {
        window.open(mutuo.url, "_blank");
    }

    return (
        <Container component="main" maxWidth="xs">
            <Card sx={{ maxWidth: 600 }}>
                <CardHeader
                    avatar={
                        <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
                            {persona ? persona.perNombre1.charAt(0).toUpperCase() : ""}
                        </Avatar>
                    }
                    /* action={
                        <IconButton aria-label="settings">
                            <MoreVertIcon />
                        </IconButton>
                    } */
                    title={persona.perNombre1 + " " + persona.perApPaterno + " " + persona.perApMaterno}
                    subheader={persona.Rut}
                />
                <CardMedia
                    component="img"
                    height="194"
                    image="/logo512.png"
                    alt="Ecora S.A."
                />
                <CardContent>
                    <Typography variant="body2" color="text.secondary">
                        {/* <p><strong>Causal:</strong> {causal.descripcion}</p>
                        <p><strong>Comentarios:</strong> {causal.comentario}</p>
                        <p><strong>Evaluación:</strong> {causal.evaluacion}</p>
                        <p><strong>Fecha Ingreso Desvinculación:</strong> {moment(causal.fecha_ingreso).format("DD-MM-YYYY")}</p> */}
                    </Typography>
                </CardContent>
                <Typography variant='6' sx={{
                    fontStyle: "inherit",
                    fontWeight: "bold",
                    textAlign: "center"
                }} paragraph>
                    Datos Trabajador
                </Typography>
                <CardContent>
                    <Typography paragraph>
                        <p><strong>Unidad de Negocio:</strong> {persona.ctoDescripcion}</p>
                        <p><strong>Cargo:</strong> {persona.recDescripcion}</p>
                        <p><strong>Fecha de Contrato:</strong> {moment(persona.FechaContratoInicial).format("DD-MM-YYYY")}</p>
                    </Typography>
                </CardContent>
                <Typography variant='6' sx={{
                    fontStyle: "inherit",
                    fontWeight: "bold",
                    textAlign: "center"
                }} paragraph>
                    Comentarios Iniciales
                </Typography>
                <CardContent>
                    <Typography paragraph>
                        {/* <p>{mutuo.comentario_inicial}</p> */}
                        <p>Solicitud de Mutuo Acuerdo Aprobada.</p>
                    </Typography>
                </CardContent>
                <Box sx={{
                    margin: 3,
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <Typography variant='6' sx={{
                        fontStyle: "inherit",
                        fontWeight: "bold",
                        textAlign: "center"
                    }} paragraph>
                        Carta Mutuo Acuerdo:
                    </Typography>
                    <Typography paragraph>
                        {/* <p>{mutuo.comentario_final}</p> */}
                        <Button variant="contained" onClick={abrirRuta}>DESCARGAR CARTA</Button>
                    </Typography>
                    {/* <TextField
                        label="Comentarios"
                        fullWidth
                        multiline
                        rows={4}
                        onChange={(e) => setComentario(e.target.value)}
                    /> */}
                </Box>
                {/* <Box sx={{
                    margin: 3,
                    alignItems: 'end',
                    justifyContent: 'end',
                    display: 'flex'
                }}>
                    <Button variant="contained" color="success" onClick={enviar}>Enviar</Button>
                </Box> */}
                {/* <CardActions disableSpacing>

                    <IconButton aria-label="add to favorites">
                        <FavoriteIcon />
                    </IconButton>
                    <IconButton aria-label="share">
                        <ShareIcon />
                    </IconButton>
                    <ExpandMore
                        expand={expanded}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                    >
                        <ExpandMoreIcon />
                    </ExpandMore>
                </CardActions> */}
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <CardContent>
                        <Typography paragraph>
                            <p><strong>Unidad de Negocio:</strong> {persona.ctoDescripcion}</p>
                            <p><strong>Cargo:</strong> {persona.recDescripcion}</p>
                            <p><strong>Fecha de Contrato:</strong> {moment(persona.FechaContratoInicial).format("DD-MM-YYYY")}</p>
                        </Typography>
                    </CardContent>
                </Collapse>
            </Card>
        </Container>
    )
}

export default MutuoADCFinal;